"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var StyleTileV2_1 = __importDefault(require("../StyleTileV2/StyleTileV2"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var StyleItem = (function (_super) {
    __extends(StyleItem, _super);
    function StyleItem() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.applyStyleToBlock = function () {
            var _a = _this.props, blockStyleStore = _a.blockStore.blockStyleStore, style = _a.style, setAppliedStyleId = _a.setAppliedStyleId, savedStyleService = _a.savedStyleService;
            savedStyleService.cloneSavedStyleToBlock(blockStyleStore, style);
            setAppliedStyleId(style._id);
        };
        _this.handleDuplicateClick = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.styleModalService.showSaveModal(this.props.style)];
                    case 1:
                        _a.sent();
                        this.trackOnly("Block Styles Cloned");
                        return [2];
                }
            });
        }); };
        _this.handleDeleteClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, styleModalService, savedStyleService, blockStore, style;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, styleModalService = _a.styleModalService, savedStyleService = _a.savedStyleService, blockStore = _a.blockStore, style = _a.style;
                        return [4, styleModalService.showDeleteModal(style)];
                    case 1:
                        _b.sent();
                        savedStyleService.trackDeleteStyle(blockStore.blockType);
                        return [2];
                }
            });
        }); };
        _this.handleRenameClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, styleModalService, style;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, styleModalService = _a.styleModalService, style = _a.style;
                        return [4, styleModalService.showRenameModal(style)];
                    case 1:
                        _b.sent();
                        this.trackOnly("Block Styles Renamed");
                        return [2];
                }
            });
        }); };
        _this.handleOnStyleItemClick = function () {
            var _a = _this.props, blockStore = _a.blockStore, style = _a.style;
            var blockStyleStore = blockStore.blockStyleStore;
            if (blockStyleStore.model.clonedFrom !== style._id) {
                _this.applyStyleToBlock();
                _this.trackOnly("Block Styles Applied", {
                    block_styles_applied_type: blockStore.blockType,
                });
            }
        };
        _this.handleResetChangesClick = function () {
            _this.applyStyleToBlock();
            _this.trackOnly("Block Styles Changes Reverted");
        };
        _this.handleUpdateStyleClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, blockStyleStore, styleModalService, isApplied, updateType;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, blockStyleStore = _a.blockStore.blockStyleStore, styleModalService = _a.styleModalService, isApplied = _a.isApplied;
                        if (!isApplied) return [3, 2];
                        return [4, styleModalService.showUpdateModal(blockStyleStore.model)];
                    case 1:
                        updateType = _b.sent();
                        if (updateType) {
                            this.trackOnly("Block Styles Changes Saved", {
                                block_styles_changes_saved_type: "current_project_and_new",
                            });
                        }
                        _b.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        _this.isDefaultStyle = function () {
            var style = _this.props.style;
            return style.name === "Default Style";
        };
        _this.trackOnly = function (name, parameters) {
            return _this.props.telemetry.trackOnly(name, parameters || {}, {
                blockIntercom: true,
            });
        };
        return _this;
    }
    StyleItem.prototype.componentDidMount = function () {
        this.containerRef = react_1.default.createRef();
    };
    StyleItem.prototype.render = function () {
        var _a = this.props, style = _a.style, isApplied = _a.isApplied, isEditable = _a.isEditable, brandStore = _a.brandStore;
        var styleChanged = this.styleChanged;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)({
                "style-item": true,
                "style-item--with-action-panel": isEditable,
                "style-item--is-applied": isApplied,
            }), ref: this.containerRef },
            react_1.default.createElement("div", { className: "style-item__container", onClick: this.handleOnStyleItemClick },
                react_1.default.createElement("div", { className: "style-item__left" },
                    react_1.default.createElement("div", { className: "style-item__style-tile" },
                        react_1.default.createElement(StyleTileV2_1.default, { style: style, size: "small", colors: brandStore.allColors })),
                    react_1.default.createElement("div", { className: "style-item__description" },
                        react_1.default.createElement("div", { className: "style-item__name" }, style.name),
                        styleChanged && react_1.default.createElement("div", { className: "style-item__subtitle" }, "Changes made"))),
                react_1.default.createElement("div", { className: "style-item__status-container" },
                    isApplied && (react_1.default.createElement("div", { className: "style-item__selected-icon" },
                        react_1.default.createElement(icons_1.Tick, null))),
                    isEditable && (react_1.default.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, className: "style-item__actions" },
                        react_1.default.createElement(kaleidoscope_2.OptionMenu, { className: "style-item__option-menu", button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null), size: kaleidoscope_1.ButtonSize.Small }), autoStack: true },
                            isApplied && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(kaleidoscope_2.OptionMenuItem, { disabled: !styleChanged, onClick: this.handleUpdateStyleClick }, "Save changes"),
                                react_1.default.createElement(kaleidoscope_2.OptionMenuItem, { disabled: !styleChanged, onClick: this.handleResetChangesClick }, "Revert changes"))),
                            react_1.default.createElement(kaleidoscope_2.OptionMenuItem, { disabled: this.isDefaultStyle(), onClick: this.handleRenameClick }, "Rename"),
                            react_1.default.createElement(kaleidoscope_2.OptionMenuItem, { onClick: this.handleDuplicateClick }, "Duplicate"),
                            react_1.default.createElement(kaleidoscope_3.OptionMenuSeparator, null),
                            react_1.default.createElement(kaleidoscope_2.OptionMenuItem, { disabled: this.isDefaultStyle(), onClick: this.handleDeleteClick, destructive: true }, "Delete"))))))));
    };
    Object.defineProperty(StyleItem.prototype, "styleChanged", {
        get: function () {
            var _a = this.props, blockStyleStore = _a.blockStore.blockStyleStore, style = _a.style;
            return blockStyleStore.model.clonedFrom === style._id && blockStyleStore.model.hash !== style.hash;
        },
        enumerable: false,
        configurable: true
    });
    StyleItem.defaultProps = {
        isEditable: true,
    };
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], StyleItem.prototype, "styleChanged", null);
    StyleItem = __decorate([
        mobx_react_1.observer
    ], StyleItem);
    return StyleItem;
}(react_1.default.Component));
exports.default = StyleItem;
